import React from "react";
import { SALE_OPTIONS } from "../data/saleOptions";

/**
 * iter247 — Optional multi-select of "sale method" chips. Compact,
 * on-brand pill UI matching the CARTAL form style. Value is a
 * string[] of ids from SALE_OPTIONS; unknown ids are ignored. Fully
 * bilingual (RTL/LTR) and touch-friendly on mobile.
 */
export default function SaleOptionsChips({ value = [], onChange, lang = "ar" }) {
  const toggle = (id) => {
    const set = new Set(value || []);
    if (set.has(id)) set.delete(id); else set.add(id);
    onChange(Array.from(set));
  };
  return (
    <div className="space-y-2" data-testid="sale-options-chips">
      <label className="text-xs text-[#6b6b6b]">
        {lang === "ar" ? "خيارات البيع (اختياري)" : "Sale options (optional)"}
      </label>
      <div className="flex flex-wrap gap-2">
        {SALE_OPTIONS.map((opt) => {
          const active = (value || []).includes(opt.id);
          return (
            <button
              type="button"
              key={opt.id}
              onClick={() => toggle(opt.id)}
              className="inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-[13px] font-medium transition-all"
              style={{
                background: active ? "#c9a55c" : "transparent",
                color: active ? "#0a0a0a" : "#3a3a3a",
                border: `1.5px solid ${active ? "#c9a55c" : "rgba(0,0,0,0.15)"}`,
                boxShadow: active ? "0 4px 12px -4px rgba(201,165,92,0.55)" : "none",
              }}
              data-testid={`sale-option-chip-${opt.id}`}
              aria-pressed={active}
            >
              <span aria-hidden>{opt.glyph}</span>
              <span>{lang === "ar" ? opt.ar : opt.en}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
